import request from '../utils/Request';
import { Methods } from '../config';

const baseURL = 'homeScreen';

const homeScreenService = {
  getAll() {
    return request({ method: Methods.GET, resource: baseURL });
  },

  getList(data) {
    return request({ method: Methods.POST, resource: `${baseURL}/list`, data });
  },

  getById(id) {
    return request({ method: Methods.GET, resource: `${baseURL}/${encodeURIComponent(id)}` });
  },

  create(data) {
    return request({ method: Methods.POST, resource: baseURL, data });
  },

  update(id, data) {
    return request({ method: Methods.PUT, resource: `${baseURL}/${encodeURIComponent(id)}`, data });
  },

  remove(id) {
    return request({ method: Methods.DELETE, resource: `${baseURL}/${encodeURIComponent(id)}` });
  },

  updateOrder(id, data) {
    return request({ method: Methods.PUT, resource: `${baseURL}/${encodeURIComponent(id)}/order`, data });
  },

  getResolved() {
    return request({ method: Methods.GET, resource: `${baseURL}/resolved/me` });
  },

  getResolvedByUserId(userId) {
    return request({
      method: Methods.GET,
      resource: `${baseURL}/resolved/${encodeURIComponent(userId)}`,
    });
  },

  getSelectable() {
    return request({ method: Methods.GET, resource: `${baseURL}/selectable` });
  },

  setMyAssignment(homeScreenId) {
    return request({ method: Methods.PUT, resource: `${baseURL}/assignment/me`, data: { homeScreenId } });
  },

  removeMyAssignment() {
    return request({ method: Methods.DELETE, resource: `${baseURL}/assignment/me` });
  },

  setUserAssignment(userId, homeScreenId) {
    return request({
      method: Methods.PUT,
      resource: `${baseURL}/assignment/users/${encodeURIComponent(userId)}`,
      data: { homeScreenId },
    });
  },

  removeUserAssignment(userId) {
    return request({
      method: Methods.DELETE,
      resource: `${baseURL}/assignment/users/${encodeURIComponent(userId)}`,
    });
  },

  setUserGroupAssignment(userGroupId, homeScreenId) {
    return request({
      method: Methods.PUT,
      resource: `${baseURL}/assignment/user-groups/${encodeURIComponent(userGroupId)}`,
      data: { homeScreenId },
    });
  },

  removeUserGroupAssignment(userGroupId) {
    return request({
      method: Methods.DELETE,
      resource: `${baseURL}/assignment/user-groups/${encodeURIComponent(userGroupId)}`,
    });
  },
};

export default homeScreenService;
